import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import * as aiccLearningAssetsAPI from "services/aiccLearningAssets";
import { useLearningAssetsStore } from "../../useLearningAssetsStore";

export function useAiccManagedLanguageNames() {
  const languages = useLearningAssetsStore((state) => state.languages);
  const setLanguages = useLearningAssetsStore((state) => state.setLanguages);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [areLanguagesFresh, setAreLanguagesFresh] = useState(false);

  useEffect(() => {
    setIsRefreshing(true);
    aiccLearningAssetsAPI
      .fetchAiccLanguageNames()
      .then(setLanguages)
      .catch(() => setLanguages([]))
      .finally(() => {
        setIsRefreshing(false);
        setAreLanguagesFresh(true);
      });
  }, [setLanguages]);

  // 🔴 The store keeps the last page's list until this mount's read lands, and it lacks a language added since.
  return { languages, areLanguagesFresh, isLanguagesLoading: isRefreshing && isEmpty(languages) };
}
